import React from "react";
import LmsTable from "../ui/LmsTable";

const LmsLoanGmr = () => {
  const actionsButtons = ["export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="gmr"
    columnClickOptions={{
      documentFileName: { downloadPath: "gmr/documents", idProp: "id" }
    }}
    columnLabelsDictionary={{
      gmrscore: "GMR Score",
      loanOfficerOrganizationContact: "Loan Officer",
      creditScore: "What is your estimated credit score?",
      loanProgram: "What type of loan are you looking for?",
      refinancePayoff: "What is the purchase price or refinance payoff of the property?",
      asIsValue: "What is the As Is Value of the property?",
      afterRepairValue: "What is the expected finished value of the project?",
      budget: "What is your requested rehab/construction budget?",
      projectZipCode: "What Zip Code is your project located in?",
      cashDown: "What is your requested cash down payment?",
      useInterestReserve: "Would you prefer an interest reverse or to make monthly payments?",
      haveYouPutAnyMoneyIntoTheProject: "Have you paid for any costs on the project to date?",
      interestRate: "Revised Interest Rate",
      borrowerOrganization: "Borrower",
      gmrnumber: "GMR Number",
      loanNumber: "Loan #",
      applicationNumber: "Application #"
    }}
  />;
};

export default LmsLoanGmr;